import React, { useMemo } from 'react'

import EmptyPlaceholder from 'components_new/molecules/EmptyPlaceholder'

import InvalidMetrics from '../InvalidMetrics'

import { useMetrics } from 'redux/hooks/Metrics'
import { useTranslation } from 'language/translator'

interface InactiveProps {
  embedded: boolean
  inactive: string[]
  scaleFactor: number
}

const Inactive = (props: InactiveProps) => {
  const { embedded, inactive, scaleFactor } = props

  const { t, lang } = useTranslation()
  const [metrics] = useMetrics()

  const inactiveMetrics = useMemo(() => {
    if (embedded) {
      return []
    }

    return inactive.map((id) => {
      const exists = metrics.find((item) => item.id === id)

      return {
        id,
        title: exists?.title[lang] || t('metrics', 'metric')
      }
    })
  }, [inactive, metrics, lang])

  if (embedded) {
    return (
      <EmptyPlaceholder
        background={true}
        scaleFactor={scaleFactor}
        title={t('widgets', 'inactive_metrics_error')}
        icon="VisibilityOffOutlined"
      />
    )
  }

  return (
    <EmptyPlaceholder
      background={true}
      scaleFactor={scaleFactor}
      title={
        <>
          {t('widgets', 'inactive_metrics_error')}
          <InvalidMetrics metrics={inactiveMetrics} />
        </>
      }
      icon="VisibilityOffOutlined"
    />
  )
}

export default Inactive
